import { render, staticRenderFns } from "./VozyNaCesteList.vue?vue&type=template&id=e136788e&"
import script from "./VozyNaCesteList.vue?vue&type=script&lang=ts&"
export * from "./VozyNaCesteList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports